import Vue from 'vue'
import Vuex from 'vuex'
//首页侧边开关
import tab from './modules/tab'
//token模块vuex
import token from './modules/token'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    tab,
	  token
  }
})

export default store
